import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableReportPdfRender = Loadable({
  loader: function loader() {
    return import('../ReportPdfRender.jsx');
  },
  loading: ComponentLoading
});
export default LoadableReportPdfRender;